<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd :title="'OFs'" :description="'Nouvel OF'" />
      </div>
      <div class="col-md-6 mt-4">
        <div class="row" v-if="selectedProduit">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex">
                  <td class="col-12 text-center font-weight-bold">
                    Produit concerné
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-8 text-custom-primary">
                    Désignation : {{ selectedProduit.designation }}
                  </td>
                  <td class="col-4 text-custom-primary">
                    Référence : {{ selectedProduit.reference }}
                  </td>
                </tr>
                <tr class="d-flex">
                  <td class="col-6 font-weight-bold">
                    Type : {{ selectedProduit.type }}
                  </td>
                  <td class="col-6 font-weight-bold">
                    Stock :
                    {{ selectedProduit.stock + ' ' + selectedProduit.unite }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <b-alert
          :show="form.errors.has('produit')"
          dismissible
          variant="danger"
          class="mt-1"
        >
          <span v-html="form.errors.get('produit')"></span>
        </b-alert>
        <div class="row">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-custom-primary mr-4"
              style="min-width: 100px"
              @click="showModalSelectOfProduit()"
            >
              Choisir le produit
            </button>
            <button
              type="button"
              class="btn btn-danger"
              style="min-width: 100px"
              @click="unSelectOfProduit"
            >
              Dissocier le produit
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row d-flex justify-content-lg-center">
                  <div class="col-md-4 col-lg-2">
                    <div class="form-group">
                      <label for="date_besoin"
                        >Date du besoin
                        <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_besoin"
                        name="date_besoin"
                        placeholder="Date du besoin"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_besoin'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_besoin"></has-error>
                    </div>
                  </div>
                  <div class="col-md-8 col-lg-3 mt-n4 mt-md-0">
                    <div class="form-group">
                      <label for="nomenclature"
                        >Nomenclature <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="libelle"
                        :options="nomenclatures"
                        :reduce="(nomenclature) => nomenclature.uuid"
                        v-model="form.nomenclature"
                        placeholder="Nomenclature"
                        @input="onChangeNomenclature"
                      >
                        <template
                          v-slot:option="{
                            libelle,
                            quantite_reference,
                            quantite_min,
                          }"
                        >
                          <h5 style="margin: 0">{{ libelle }}</h5>
                          <span class="d-block" v-if="quantite_reference">
                            Quantité de référence :
                            {{
                              quantite_reference + ' ' + selectedProduit.unite
                            }}
                          </span>
                          <span class="d-block" v-if="quantite_min">
                            Quantité min :
                            {{ quantite_min + ' ' + selectedProduit.unite }}
                          </span>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="nomenclature"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('nomenclature'),
                          }"
                        />
                        <has-error
                          :form="form"
                          field="nomenclature"
                        ></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 mt-n4 mt-lg-0">
                    <div class="form-group">
                      <label for="libelle"
                        >Libellé <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('libelle') }"
                        id="libelle"
                        v-model="form.libelle"
                        type="text"
                        placeholder="Libellé"
                        maxlength="100"
                      />
                      <has-error :form="form" field="libelle"></has-error>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-2 mt-n4 mt-lg-0">
                    <div class="form-group">
                      <label for="quantite"
                        >Quantité <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('quantite'),
                        }"
                        id="quantite"
                        v-model="form.quantite"
                        type="text"
                        placeholder="Quantité"
                      />
                      <has-error :form="form" field="quantite"></has-error>
                    </div>
                  </div>

                  <div class="col-md-3 col-lg-2 mt-n4 mt-lg-0">
                    <div class="form-group">
                      <label for="priorite"
                        >Priorité <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="priorites"
                        :reduce="(priorite) => priorite.uuid"
                        v-model="form.priorite"
                        placeholder="Priorité"
                      >
                        <template v-slot:option="{ nom, couleur }">
                          <h5 style="margin: 0">
                            <i
                              :style="`color: ${couleur}`"
                              class="fa fa-circle mr-1"
                            ></i>
                            {{ nom }}
                          </h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="priorite"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('priorite'),
                          }"
                        />
                        <has-error :form="form" field="priorite"></has-error>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.nomenclature">
          <div class="row mt-n4">
            <div class="col-lg-12">
              <div role="tablist">
                <b-card
                  no-body
                  class="mb-2"
                  v-for="(item, index) in item_lists"
                  :key="index"
                >
                  <b-card-header
                    header-tag="header"
                    role="tab"
                    v-b-toggle="'accordion-' + (index + 1)"
                    header-class="bg-silver"
                  >
                    <span class="when-open">
                      <h6 class="m-0">
                        <a class="text-dark" href="javascript: void(0);">{{
                          item.libelle
                            ? 'Etape ' + (index + 1) + ' : ' + item.libelle
                            : 'Etape ' + (index + 1)
                        }}</a>
                        <span class="accicon">
                          <i :class="create.ICON_ANGLE_UP"></i>
                        </span>
                      </h6>
                    </span>
                    <span class="when-closed">
                      <h6 class="m-0">
                        <a class="text-dark" href="javascript: void(0);">{{
                          item.libelle
                            ? 'Etape ' + (index + 1) + ' : ' + item.libelle
                            : 'Etape ' + (index + 1)
                        }}</a>
                        <span class="accicon">
                          <i :class="create.ICON_ANGLE_DOWN"></i>
                        </span>
                      </h6>
                    </span>
                  </b-card-header>
                  <b-collapse
                    style="background-color: #f3f3f3"
                    :id="'accordion-' + (index + 1)"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <div class="row mb-n4 mt-0">
                      <div class="col-12">
                        <div class="card">
                          <table class="table table-sm table-bordered">
                            <thead>
                              <tr>
                                <th scope="col">Libellé</th>
                                <th scope="col">Poste de charge</th>
                                <th scope="col">Nature étape</th>
                                <th scope="col">Checklist</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{{ item.libelle }}</td>
                                <td>{{ item.poste_charge.nom }}</td>
                                <td>
                                  <b-badge variant="primary" v-if="item.debut"
                                    >Début</b-badge
                                  >
                                  <b-badge
                                    variant="success"
                                    class="ml-1"
                                    v-if="item.fin"
                                    >Fin</b-badge
                                  >
                                  <b-badge
                                    variant="primary"
                                    class="ml-1"
                                    v-if="!item.debut && !item.fin"
                                    >Intermediaire</b-badge
                                  >
                                </td>
                                <td>
                                  <b-badge
                                    variant="primary"
                                    v-for="(
                                      checklist, indexC
                                    ) in item.selected_checklists"
                                    :key="indexC"
                                    >{{ checklist.nom }}</b-badge
                                  >
                                  <b-badge
                                    variant="primary"
                                    class="ml-1"
                                    v-if="item.selected_checklists.length === 0"
                                    >Pas de checklists</b-badge
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-n2 mb-n4">
                      <div class="col-md-12 col-lg-6">
                        <b-card
                          no-body
                          class="text-black"
                          header-class="bg-silver"
                        >
                          <template v-slot:header>
                            <div class="row">
                              <div class="col-md-12 text-lg-left text-center">
                                <span class="font-weight-bold"
                                  >Consommation des matières premières</span
                                >
                              </div>
                            </div>
                          </template>
                          <div class="row">
                            <div class="col-12">
                              <table class="table table-sm">
                                <thead>
                                  <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Désignation</th>
                                    <th scope="col">Référence</th>
                                    <th scope="col">Quantité</th>
                                    <th scope="col">Stock</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(article, index3) in item.matieres"
                                    :key="index3"
                                  >
                                    <th scope="row">{{ index3 + 1 }}</th>
                                    <td>
                                      {{ article.designation }}
                                    </td>
                                    <td>{{ article.reference }}</td>
                                    <td>
                                      {{
                                        (form.quantite * article.quantite) /
                                          form.quantite_reference +
                                        ' ' +
                                        article.unite
                                      }}
                                    </td>
                                    <td
                                      :class="{
                                        'text-danger':
                                          article.stock <
                                          (form.quantite * article.quantite) /
                                            form.quantite_reference,
                                      }"
                                    >
                                      {{ article.stock + ' ' + article.unite }}
                                    </td>
                                  </tr>

                                  <tr v-if="item.matieres.length === 0">
                                    <td class="text-center" colspan="5">
                                      Aucune donnée
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </b-card>
                      </div>
                      <div class="col-md-12 col-lg-6">
                        <b-card
                          no-body
                          class="text-black"
                          header-class="bg-silver"
                        >
                          <template v-slot:header>
                            <div
                              class="row"
                              v-if="
                                lastItem &&
                                lastItem.identifiant === item.identifiant
                              "
                            >
                              <div class="col-md-12 text-md-left text-center">
                                <span class="font-weight-bold"
                                  >Produit fini à fabriquer
                                </span>
                              </div>
                            </div>
                            <div class="row" v-else>
                              <div class="col-md-12 text-lg-left text-center">
                                <span class="font-weight-bold"
                                  >Produits semi-finis à fabriquer
                                </span>
                              </div>
                            </div>
                          </template>
                          <div class="row">
                            <div class="col-12">
                              <table class="table table-sm">
                                <thead>
                                  <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Désignation</th>
                                    <th scope="col">Référence</th>
                                    <th scope="col">Quantité</th>
                                    <th scope="col">Stock</th>
                                  </tr>
                                </thead>
                                <tbody
                                  v-if="
                                    lastItem &&
                                    lastItem.identifiant === item.identifiant
                                  "
                                >
                                  <tr>
                                    <th scope="row">1</th>
                                    <td>
                                      {{ selectedProduit.designation }}
                                    </td>
                                    <td>{{ selectedProduit.reference }}</td>
                                    <td>
                                      {{
                                        form.quantite +
                                        ' ' +
                                        selectedProduit.unite
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        selectedProduit.stock +
                                        ' ' +
                                        selectedProduit.unite
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody v-else>
                                  <template
                                    v-for="(article, index3) in item.produits"
                                  >
                                    <tr :key="index3">
                                      <th scope="row">{{ index3 + 1 }}</th>
                                      <td>
                                        {{ article.designation }}
                                      </td>
                                      <td>{{ article.reference }}</td>
                                      <td>
                                        {{
                                          (form.quantite * article.quantite) /
                                            form.quantite_reference +
                                          ' ' +
                                          article.unite
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          article.stock + ' ' + article.unite
                                        }}
                                      </td>
                                    </tr>
                                  </template>

                                  <tr v-if="item.produits.length === 0">
                                    <td class="text-center" colspan="5">
                                      Aucune donnée
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </b-card>
                      </div>
                    </div>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>

          <div class="row mt-n4" v-if="statutMatieres.length > 0">
            <div class="col-lg-12">
              <div role="tablist">
                <b-card no-body class="mb-2">
                  <b-card-header
                    header-tag="header"
                    role="tab"
                    v-b-toggle="'accordion-resume'"
                    header-class="bg-silver"
                  >
                    <span class="when-open">
                      <h6 class="m-0">
                        <a class="text-dark" href="javascript: void(0);"
                          >Resumé de l'OF</a
                        >
                        <span class="accicon">
                          <i :class="create.ICON_ANGLE_UP"></i>
                        </span>
                      </h6>
                    </span>
                    <span class="when-closed">
                      <h6 class="m-0">
                        <a class="text-dark" href="javascript: void(0);"
                          >Resumé de l'OF</a
                        >
                        <span class="accicon">
                          <i :class="create.ICON_ANGLE_DOWN"></i>
                        </span>
                      </h6>
                    </span>
                  </b-card-header>
                  <b-collapse
                    style="background-color: #f3f3f3"
                    id="accordion-resume"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <div class="row p-2">
                      <div class="col-12">
                        <p>Resumé des matières premières de l'OF</p>
                      </div>
                    </div>

                    <div class="row mt-n4">
                      <div class="col-12">
                        <div class="card">
                          <table class="table table-sm table-bordered">
                            <thead>
                              <tr>
                                <th scope="col">Etape</th>
                                <th scope="col">Matière prémière</th>
                                <th scope="col">Quantité requise</th>
                                <th scope="col">Stock</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template
                                v-for="(etape, etapeKey) in statutMatieres"
                              >
                                <tr
                                  v-for="(matiere, Mkey) in etape.matieres"
                                  :key="etapeKey + '-' + Mkey"
                                >
                                  <td
                                    v-if="Mkey === 0"
                                    :rowspan="etape.matieres.length"
                                    class="vertical-align"
                                  >
                                    {{ etape.libelle }}
                                  </td>
                                  <td>{{ matiere.designation }}</td>
                                  <td>
                                    {{
                                      (form.quantite * matiere.quantite) /
                                        form.quantite_reference +
                                      ' ' +
                                      matiere.unite
                                    }}
                                  </td>
                                  <td
                                    :class="{
                                      'text-danger':
                                        matiere.stock <
                                        (form.quantite * matiere.quantite) /
                                          form.quantite_reference,
                                    }"
                                  >
                                    {{ matiere.stock + ' ' + matiere.unite }}
                                  </td>
                                </tr>
                              </template>

                              <tr v-if="statutMatieres.length === 0">
                                <td class="text-center" colspan="4">
                                  Toutes les matières nécessaire à la
                                  réalisation de cet OF sont disponible
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="$router.push({ name: 'gpao_of' }).catch(() => {})"
            >
              Liste des OFs
            </button>

            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Créer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
    <ModalSelectProduit
      ref="modalSelectProduit"
      :selectedProduit="selectedProduit"
      :titleModal="titleModal"
      @onProduitSelected="onProduitSelected"
    />
  </div>
</template>

<script>
import URL_O from '@/http/gpao/of';
import { create } from '@/icons/gpao/of';
import URL_N from '@/http/gpao/nomenclature';
import DatePicker from 'vue2-datepicker';
import Form from 'vform';
import ModalSelectProduit from './modals/ModalSelectProduit.vue';

export default {
  data() {
    return {
      create,
      form: new Form({
        date_besoin: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        nomenclature: '',
        libelle: '',
        quantite: 1,
        quantite_reference: 1,
        priorite: '',
      }),
      item_lists: [],
      selectedProduit: null,
      priorites: [],
      titleModal: '',
      visibleEtape: 0,

      title: 'Gestion des OFs - Création',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    ModalSelectProduit,
    DatePicker,
  },
  computed: {
    nomenclatures() {
      return this.selectedProduit ? this.selectedProduit.nomenclatures : [];
    },
    firstItem() {
      return this.item_lists.find((item) => item.debut === true) || null;
    },
    lastItem() {
      return this.item_lists.find((item) => item.fin === true) || null;
    },
    statutMatieres() {
      let matieres = [];

      this.item_lists.map((item) => {
        let currentData = window._.filter(
          item.matieres,
          (matiere) =>
            matiere.stock <
            (this.form.quantite * matiere.quantite) /
              this.form.quantite_reference
        );
        if (currentData.length > 0) {
          matieres.push({
            libelle: item.libelle,
            matieres: currentData,
          });
        }
      });

      return matieres;
    },
  },
  methods: {
    init() {
      this.item_lists = [];
      this.priorites = [];

      this.selectedProduit = null;

      window.axios
        .get(URL_O.GET_REQUIREMENTS)
        .then((resp) => {
          this.priorites = resp.data.priorites;
        })
        .catch();
    },
    onChangeNomenclature() {
      let currentNomenclature = window._.find(
        this.nomenclatures,
        (n) => n.uuid === this.form.nomenclature
      );

      if (currentNomenclature)
        window.axios
          .get(URL_N.NOMENCLATURE + '/' + currentNomenclature.id)
          .then((resp) => {
            this.form.quantite = resp.data.nomenclature.quantite_min;
            this.form.quantite_reference =
              resp.data.nomenclature.quantite_reference;
            this.item_lists = resp.data.nomenclature.item_lists;
          })
          .catch();
    },
    showModalSelectOfProduit() {
      this.titleModal = "Sélection du produit de l'OF";
      this.$nextTick(() => {
        this.$refs.modalSelectProduit.showModal();
      });
    },
    unSelectOfProduit() {
      this.titleModal = '';
      this.selectedProduit = null;
      this.form.reset();
      this.init();
    },
    onProduitSelected(produit) {
      this.selectedProduit = produit;
      if (this.selectedProduit.nomenclatures.length === 1) {
        this.form.nomenclature = this.selectedProduit.nomenclatures[0].uuid;
        this.onChangeNomenclature();
      }
    },

    submit() {
      this.visibleEtape = -1;

      if (this.selectedProduit) {
        this.form.produit = this.selectedProduit.resource_uuid;
      }

      let produit = [
        {
          uuid: this.selectedProduit.uuid,
          designation: this.selectedProduit.designation,
          reference: this.selectedProduit.reference,
          unite: this.selectedProduit.unite,
          quantite: this.form.quantite,
          stock: this.selectedProduit.stock,
          type: this.selectedProduit.type,
        },
      ];

      this.form.item_lists = this.item_lists.map((item) => {
        return {
          identifiant: item.identifiant,
          libelle: item.libelle,
          poste_charge: item.poste_charge.uuid,
          debut: item.debut,
          fin: item.fin,
          matieres: item.matieres,
          produits: item.fin ? produit : item.produits,
          dependances: item.selected_dependances.map(
            (dependance) => dependance.identifiant
          ),
          checklists: item.selected_checklists.map(
            (checklist) => checklist.uuid
          ),
        };
      });

      this.form
        .post(URL_O.OF)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.$router.push({
            name: 'gpao_of-show',
            params: { id: resp.data.of.id },
          });
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (_value, key) => {
            if (key.includes('item_lists')) {
              this.visibleEtape = Number(key[10]);
              return false;
            }
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.card-header .accicon {
  float: right;
}
.card-header {
  cursor: pointer;
  border-bottom: 5px;
}
.card {
  border: 1px solid #ddd;
}

.bg-silver {
  background-color: transparent;
  border-color: #ced4da;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
